import { decode } from "html-entities";
import { ReactComponent as OTick } from "Assets/Images/icn/OrangeTick.svg";

const CheckBoxes = ({ question }) => {
  let checkOptions = null;
  try {
    checkOptions = JSON.parse(question.other_column_data);
  } catch (error) {
    console.log("Error while parsing radio options", question.question);
  }

  return (
    <ul className="list-unstyled ps-0 mb-0 py-2">
      {checkOptions &&
        checkOptions.length > 0 &&
        checkOptions.map((option, i) => {
          let optionValue = "";
          if (
            option !== null &&
            typeof option === "object" &&
            !Array.isArray(option) &&
            typeof option.answer !== "undefined"
          ) {
            optionValue = option.answer;
          } else {
            optionValue = option;
          }

          return (
            <li>
              <div className="py-1 d-flex align-items-start">
                <div className="cstmInputCheckWrp previewFormField position-relative me-2">
                  <input type="checkbox" className={`position-absolute`} disabled />
                  <div className="cstmInputCheck h-100 w-100 d-flex align-items-center justify-content-center">
                    <span className="icn d-none">
                      <OTick />
                    </span>
                  </div>
                </div>
                <p className="m-0 ">{decode(optionValue)}</p>
              </div>
            </li>
          );
        })}
    </ul>
  );
};

export default CheckBoxes;
